import { Shield, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
interface OTPActionsProps {
  onVerify: () => void;
  onBackToSignIn: () => void;
  isVerifying: boolean;
  disabled: boolean;
}
export const OTPActions = ({ 
  onVerify, 
  onBackToSignIn, 
  isVerifying, 
  disabled 
}: OTPActionsProps) => {
  return (
    <div className="space-y-4">
      {/* Verify Button */}
      <Button
        onClick={onVerify}
        disabled={disabled}
        className={`w-full h-14 text-lg font-semibold rounded-full transition-all duration-200 flex items-center justify-center gap-3 ${
          disabled
            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
            : 'bg-primary-blue text-white hover:bg-primary-blue/90 active:scale-95'
        }`}
      >
        {isVerifying ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            <span className="">Verifying...</span>
          </>
        ) : (
          <>
            <Shield className="w-5 h-5" />
            <span className={disabled ? '' : 'text-white'}>Verify OTP</span>
          </>
        )}
      </Button>
      {/* Back to Sign In */}
      <Button
        onClick={onBackToSignIn}
        variant="outline"
        className="w-full h-12 border-gray-300 text-gray-700 hover:bg-gray-50 flex items-center justify-center gap-2"
        disabled={isVerifying}
      >
        <ArrowLeft className="w-4 h-4" />
        <span>Back to Sign In</span>
      </Button>
    </div>
  );
};